const CHUNK_LOAD_ERROR_PATTERNS = [
  "failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "importing a module script failed",
  "failed to load module script",
  "chunkloaderror",
  "loading chunk",
] as const;

const SERVER_CONNECTION_ERROR_PATTERNS = ["err_connection_refused", "err_network_changed"] as const;

function collectErrorText(error: unknown, seen = new Set<unknown>()): string {
  if (error === null || error === undefined || seen.has(error)) {
    return "";
  }
  seen.add(error);

  if (typeof error === "string") {
    return error;
  }

  if (error instanceof Error) {
    return [
      error.name,
      error.message,
      "cause" in error ? collectErrorText(error.cause, seen) : "",
    ].join(" ");
  }

  if (typeof error === "object") {
    const record = error as Record<string, unknown>;
    return [
      typeof record.name === "string" ? record.name : "",
      typeof record.message === "string" ? record.message : "",
      collectErrorText(record.cause, seen),
    ].join(" ");
  }

  return String(error);
}

export function isServerConnectionError(error: unknown): boolean {
  const text = collectErrorText(error).toLowerCase();
  if (!text) {
    return false;
  }

  return SERVER_CONNECTION_ERROR_PATTERNS.some((pattern) => text.includes(pattern));
}

export function isChunkLoadError(error: unknown): boolean {
  const text = collectErrorText(error).toLowerCase();
  if (!text) {
    return false;
  }

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => text.includes(pattern));
}
